import { ApiResponse, HTTPVerb } from '../Modules/Utils/API/Interfaces/IApi';
import { ApiManager } from '../Modules/Utils/API/ApiManager';

enum APIConstants {
    GetClientProductPackageAuthenticated = '/api/OpenClientProductPackage/',
    GetClientProductPackageUnauthorized = '/api/OpenClientProductPackageController/UnauthorizedOpenClient/',
}

export interface IOpenClientProductPackageDataRequest {
    ProductOfferingId: number;
    SubBrandId: number;
    ProductPackageId: number;
    IsRealMode: number;
    AdditionalActivationParameters?: string;
}

export interface IClientProductPackageApiResponse {
    MessagesDetails?: string;
    ErrorCode?: number;
    ErrorDescription?: string;
    IsOk: boolean;
}

export default class ClientProductPackageApi {
    public static GetClientProductPackageDataAuthenticated = async (
        data: IOpenClientProductPackageDataRequest,
    ): Promise<ApiResponse<IClientProductPackageApiResponse>> => {
        return ApiManager.getAPIInstance().authenticatedRequest({
            url: APIConstants.GetClientProductPackageAuthenticated,
            method: HTTPVerb.POST,
            data,
        });
    };

    public static GetClientProductPackageDataUnauthorized = async (
        data: IOpenClientProductPackageDataRequest,
    ): Promise<ApiResponse<IClientProductPackageApiResponse>> => {
        return ApiManager.getAPIInstance().request({
            url: APIConstants.GetClientProductPackageUnauthorized,
            method: HTTPVerb.POST,
            data,
        });
    };
}
